<template>
  <!-- Escape and a click outside close it like Cancel, except while the request is in flight -->
  <v-dialog
    :value="true"
    :persistent="loading"
    max-width="560px"
    @input="$emit('cancel')"
  >
    <v-card class="p-5 p-md-8">
      <ModalHeading
        modalTitle="Why is this talent not relevant?"
        :modalDesc="talentName"
      />
      <form class="form pt-3" @submit.prevent="confirm">
        <v-radio-group v-model="reason" hide-details class="mt-0">
          <v-radio
            v-for="option in reasons"
            :key="option.id"
            :label="option.name"
            :value="option.id"
            color="primary"
            class="not-relevant-modal__reason"
          ></v-radio>
        </v-radio-group>
        <v-textarea
          v-if="reason === 'other'"
          v-model="note"
          class="mt-4"
          placeholder="Add additional details..."
          outlined
          dense
          hide-details
          rows="3"
          maxlength="1000"
        ></v-textarea>
        <div class="text-right mt-7">
          <button
            class="btn btn-secondary font-weight-bolder px-8"
            type="button"
            :disabled="loading"
            @click="$emit('cancel')"
          >
            Cancel
          </button>
          <button
            class="btn btn-info font-weight-bolder px-8 ml-5"
            :class="{ 'spinner spinner-light spinner-right': loading }"
            :disabled="!isValid || loading"
          >
            Confirm Not Relevant
          </button>
        </div>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import ModalHeading from "@/components/UI/ModalHeading.vue";

export default {
  name: "MarkNotRelevantModal",
  components: { ModalHeading },
  props: {
    talentName: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    // The reasons to pick from ({ id, name }), as the API returns them
    reasons: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      reason: null,
      note: "",
    };
  },
  computed: {
    isValid() {
      return !!this.reason && (this.reason !== "other" || !!this.note.trim());
    },
  },
  methods: {
    confirm() {
      if (!this.isValid) return;

      this.$emit("confirm", {
        reason: this.reason,
        note: this.reason === "other" ? this.note.trim() : null,
      });
    },
  },
};
</script>

<style scoped>
.not-relevant-modal__reason {
  margin-bottom: 10px;
}
</style>
